import Swal from "sweetalert2";

/**
 * @see https://sweetalert2.github.io/#usage
 */
const SwAlert = ({
	title,
	text,
	footer,
	icon = "error" | "info" | "question" | "success" | "warning",
	iconHtml,
	showCancelButton = false,
	cancelButtonColor = "#F23030",
	cancelButtonText = "Não",
	onCancel,
	showConfirmButton = true,
	confirmButtonColor = "#652FD0",
	confirmButtonText = "Sim",
	onConfirm,
	showCloseButton = false,
	timer,
	allowOutsideClick = false,
	allowEscapeKey = false,
	reverseButtons = false,
	input = undefined,
	inputLabel = undefined,
	inputValidator = undefined,
	inputPlaceholder = undefined,
	inputAttributes = undefined,
	customClass = {
		confirmButton: undefined,
		cancelButton: undefined,
		container: undefined,
		popup: undefined,
		header: undefined,
		title: undefined,
		closeButton: undefined,
		icon: undefined,
		image: undefined,
		content: undefined,
		input: undefined,
		actions: undefined,
		footer: undefined,
	},
	onOpen,
}) =>
	Swal.fire({
		title,
		html: text,
		footer,
		icon,
		iconHtml,
		imageWidth: 80,
		imageHeight: 80,
		showCancelButton,
		cancelButtonColor,
		cancelButtonText,
		showConfirmButton,
		confirmButtonColor,
		confirmButtonText,
		showCloseButton,
		timer,
		timerProgressBar: Boolean(timer),
		allowOutsideClick,
		allowEscapeKey,
		reverseButtons,
		input,
		inputLabel,
		inputValidator,
		inputPlaceholder,
		inputAttributes,
		customClass: {
			...customClass,
			confirmButton: customClass.confirmButton ?? `btn btn-primary btn-large`,
			cancelButton: customClass.cancelButton ?? `btn btn-danger btn-large`,
		},
		focusConfirm: false,
		onOpen,
	}).then((result) => {
		if (result.isConfirmed && onConfirm) {
			onConfirm(result.value);
		} else if (result.isDismissed && onCancel) {
			onCancel();
		}
	});

export default SwAlert;
